import {useMe} from '@/features/authentication/queries/useMe'
import {REDIRECT_MAP} from '@/utilities/constants'
import {Navigate, Outlet} from 'react-router-dom'

export const HostRoute = () => {
    const {data: user, isLoading} = useMe()
    const roleOfUser = user?.type
    const allowableUsersRole = ['rookie']
    const isAdmitted = roleOfUser && allowableUsersRole.includes(roleOfUser)

    return isLoading || isAdmitted ? <Outlet /> : <Navigate to={roleOfUser ? REDIRECT_MAP[roleOfUser] : '/'} />
}
